import { forwardRef } from 'react';

export const NavigationIcon = forwardRef<SVGSVGElement, React.HTMLAttributes<SVGSVGElement>>(
  function Icon(props, ref) {
    return (
      <svg ref={ref} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M14.4034 1.38395C14.2691 1.31668 14.111 1.31668 13.9768 1.38395L1.59617 7.57422C1.361 7.69193 1.26577 7.97797 1.38346 8.21315C1.45045 8.34701 1.5765 8.4416 1.72377 8.46847L6.63743 9.36224L7.53121 14.2759C7.56779 14.4773 7.72906 14.6328 7.93167 14.6621C7.95408 14.6653 7.97668 14.6669 7.99928 14.6668C8.17977 14.6669 8.34478 14.565 8.42546 14.4035L14.6158 2.02296C14.7336 1.78784 14.6385 1.50174 14.4034 1.38395Z"
          fill="currentColor"
        />
      </svg>
    );
  },
);
